import { render, staticRenderFns } from "./NotesControl.vue?vue&type=template&id=74843a4a&"
import script from "./NotesControl.vue?vue&type=script&lang=js&"
export * from "./NotesControl.vue?vue&type=script&lang=js&"
import style0 from "./NotesControl.vue?vue&type=style&index=0&id=74843a4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports